var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon2 = function SvgLogoIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none",
    viewBox: "0 0 26 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.218 2.31a4.645 4.645 0 1 1 6.566 6.57c-.548.55-3.765 2.777-5.929 4.254-1.148.784-2 1.357-2 1.357V5.596c.001-1.232.491-2.414 1.363-3.286m1.15 8.046-.513.354V5.597a2.65 2.65 0 0 1 2.65-2.649 2.645 2.645 0 0 1 1.866 4.517l-.005.005a8 8 0 0 1-.383.308c-.252.194-.58.436-.963.713-.766.553-1.717 1.22-2.652 1.865",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.366 20.88a4.648 4.648 0 1 0-7.732-5.16 4.648 4.648 0 0 0 7.732 5.16M22.5 11.948l.94-2.06 2.06-.94-2.06-.94-.94-2.06-.94 2.06-2.06.94 2.06.94zM4.44 17.888l-.94 2.06-.94-2.06-2.06-.94 2.06-.94.94-2.06.94 2.06 2.06.94z"
  })));
};
export default SvgLogoIcon2;